import { _query, query } from '../utils/query.js'
import debounce from '../utils/debounce.js'
import { getNextSibling } from '../utils/getSibling'
import { revalidateAddressFieldsAfterGoogleAutofill } from '../utils/init-jquery-validation.js'


let service
let serviceDetails: google.maps.places.PlacesService | null = null
let serviceDetailsBilling: google.maps.places.PlacesService | null = null
window.addressObj = {}
let autocomplete_input
let autocomplete_inputBilling

const componentForm = {
	street_number: 'short_name',
	route: 'long_name',
	locality: 'long_name',
	sublocality: 'short_name',
	administrative_area_level_1: 'short_name',
	administrative_area_level_3: 'short_name',
	country: 'long_name',
	postal_code: 'short_name',
	postal_code_suffix: 'long_name',
	neighborhood: 'long_name',
}

// https://developers.google.com/maps/documentation/places/web-service/supported_types#table3
// const options = {
// 	fields: ['address_components', 'formatted_address', 'geometry', 'name'],
// 	strictBounds: false,
// 	types: ['address'],
// }

// https://blog.woosmap.com/implement-and-optimize-autocomplete-with-google-places-api
export function initAutocomplete() {
	// https://developers.google.com/maps/documentation/javascript/examples/places-autocomplete#maps_places_autocomplete-html
	// Create the autocomplete object, restricting the search to geographical
	// location types.
	autocomplete_input = _query('#address1')
	autocomplete_inputBilling = _query('#address1Billing')
	// autocomplete_results = _query('.autocomplete-results')
	// autocomplete_resultsBilling = _query('.autocomplete-results-billing')
	// autocomplete = new google.maps.places.Autocomplete(
	// 	// /** @type {!HTMLInputElement} */(document.getElementById('address1')),
	// 	autocomplete_input,
	// 	options
	// )

	service = new google.maps.places.AutocompleteService()
	serviceDetails = autocomplete_input ? new google.maps.places.PlacesService(autocomplete_input) : null
	serviceDetailsBilling =autocomplete_inputBilling ? new google.maps.places.PlacesService(autocomplete_inputBilling) : null
	// const bounds = geolocate()

	// When the user selects an address from the dropdown, populate the address
	// fields in the form.
	autocomplete_input?.addEventListener(
		'input',
		debounce(triggerGetPlacePredictions(false), 500)
	)
	autocomplete_inputBilling?.addEventListener(
		'input',
		debounce(triggerGetPlacePredictions(true), 500)
	)
}

const triggerGetPlacePredictions = (isBilling: boolean = false) => (e: Event) => {
	const target = e.target as HTMLInputElement
	const { value } = target
	const autocomplete_results = getNextSibling(target, '.autocomplete-results') as HTMLElement
	if (!autocomplete_results) {
		alert('no autocomplete results')
		return
	}
	value.replace('"', '\\"').replace(/^\s+|\s+$/g, '')
	if (value.length > 4) {
		getPlacePredictions(value, autocomplete_results, target, isBilling)
	}
}

function getPlacePredictions(value: string, autocomplete_results: HTMLElement, target: HTMLInputElement, isBilling: boolean = false) {
	// https://developers.google.com/maps/documentation/javascript/legacy/place-autocomplete#session_tokens
	const sessionToken = new google.maps.places.AutocompleteSessionToken();
	service.getPlacePredictions(
		{
			input: value,
			componentRestrictions: { country: getCountry() },
			types: ["address"], //https://developers.google.com/maps/documentation/places/web-service/legacy/autocomplete#types
			sessionToken: sessionToken,
		},
		wrapperSuggestions(value, autocomplete_results, target, sessionToken, isBilling,)
	)
}
const renderHighLight = (string: string, highLight: string) =>
	String(string).replace(
		new RegExp(highLight, 'gi'),
		`<span class="autoComplete_highlighted fw700">$&</span>`
	)

function wrapperSuggestions(value: string, autocomplete_results: HTMLElement, target: HTMLInputElement, sessionToken: google.maps.places.AutocompleteSessionToken, isBilling: boolean = false) {
	return function (predictions, status) {
		if (status !== google.maps.places.PlacesServiceStatus.OK) {
			return
		}
		// console.debug(value)
		const autocompleteBackDrop = getNextSibling(autocomplete_results, '.AutocompleteBackDrop') as HTMLElement
		if (!autocompleteBackDrop) {
			console.warn('no autocomplete back drop')
			return
		}
		autocompleteBackDrop.style.display = 'block'

		const results_html = []
		const results = []
		predictions.forEach((prediction) => {
			const { place_id, description, structured_formatting, terms } = prediction
			// console.debug(prediction)
			results.push(prediction)
			const renderResult = renderHighLight(description, value)
			results_html.push(
				`<li class="autocomplete-item" data-type="place" data-place-id=${place_id}>
					<span class="autocomplete-icon icon-localities"></span>
					<span class="autocomplete-text">${renderResult}</span>
				</li>`
			)
		})

		autocomplete_results.innerHTML = results_html.join('')
		autocomplete_results.style.display = 'block'
		const autocomplete_items =
			autocomplete_results.querySelectorAll('.autocomplete-item')

		for (const autocomplete_item of Array.from(autocomplete_items)) {
			autocomplete_item.addEventListener('click', function () {
				// const selected_text = this.querySelector('.autocomplete-text').textContent
				const place_id = this.getAttribute('data-place-id')
				const request = {
					placeId: place_id,
					fields: [
						'address_components',
						'formatted_address',
						'vicinity',
					],
					sessiontoken: sessionToken,
				}
				let addressString = ""
				for (const result of results) {
					const { description, structured_formatting, terms } = result
					if (result.place_id === place_id) {
						target.value = structured_formatting.main_text
						addressString = description
					}
				}

				isBilling ? serviceDetailsBilling?.getDetails(request, (place, status) => {
					fillInAddress(place, addressString, isBilling)
				}) : serviceDetails?.getDetails(request, (place, status) => {
					fillInAddress(place, addressString, isBilling)
				})

				autocomplete_results.style.display = 'none'
				autocompleteBackDrop.style.display = 'none'
			})
		}

		autocompleteBackDrop.addEventListener('click', () => {
			autocomplete_results.style.display = 'none'
			autocompleteBackDrop.style.display = 'none'
		})
	}
}

async function fillInAddress(place, addressString, isBilling: boolean = false) {
	window.addressObj = { country: '', street_number: '', route: '', locality: '', postal_code: '', state: '' }//order matters, country precedes state
	// Get the place details from the autocomplete object.
	// const place = autocomplete.getPlace()

	// if (!place.geometry || !place.geometry.location) {
	// 	return
	// }

	// const addressString = place.vicinity || place.formatted_address || '';
	// if (formatted_address) {
	// 	window.addressObj.formatted_address = formatted_address
	// }


	place.address_components.forEach((item: any) => {
		const addressType = item.types[0] !== 'political' ? item.types[0] : item.types[1]
		if (componentForm[addressType]) {
				if (['locality', 'postal_town', 'neighborhood', 'sublocality', 'administrative_area_level_3'].includes(addressType)) {
					// 使用 short_name 或 long_name 都可以，通常 long_name 更稳妥
					const {long_name, short_name} = item
					// 只有当地址字符串包含该城市名时，才采纳
					if (addressString.includes(short_name) || addressString.includes(long_name)) {
						window.addressObj.locality = item[componentForm[addressType]]
					}
				} else if (addressType === 'administrative_area_level_1') {
					window.addressObj.state = item[componentForm[addressType]]
				} else if (addressType === 'postal_code_suffix') {
					window.addressObj.postal_code += `-${item[componentForm[addressType]]}`
				} else {
					window.addressObj[addressType] = item[componentForm[addressType]]
				}
		}
	})

	// console.debug(place.address_components)
	console.log('window.addressObj', window.addressObj)

	await fillInToForm(isBilling)
}

// let fillInToFormOnce = false
function fillInToForm(isBilling: boolean = false) {
	const keys = Object.keys(window.addressObj)
	const values = Object.values(window.addressObj)
	values.forEach((val: string, i) => {
		if (['state', 'country'].includes(keys[i])) {
			const selector = _query(`#${keys[i]}Id${isBilling ? 'Billing' : ''}`) as HTMLSelectElement
			if (selector) {
				const options = selector.querySelectorAll('option') as NodeListOf<HTMLOptionElement>
				if (keys[i] === 'country' && selector.options[selector.selectedIndex].text.toLowerCase() !== val.toLowerCase()) {
					for (let i = 0; i < options.length; i++) {
						const option = options[i]
						if (option.text.toLowerCase() === val.toLowerCase()) {
							selector.value = option.getAttribute('value') as string
						}
					}
					const event = new Event('change')
					selector.dispatchEvent(event)
				} else if (keys[i] === 'state') {
					for (let i = 0; i < options.length; i++) {
						const option = options[i]
						if (option.getAttribute('brief') === val) {
							// brief="NY"
							selector.value = option.getAttribute('value') as string
						}
					}
				}
			}
		} else {
			const keyFields = query(`[data-address-key${isBilling ? 'billing' : ''}=${keys[i]}]`)
			for (const keyField of keyFields) {
				if (keyField !== null) {
					keyField.value = val
				}
			}
		}
	})
	revalidateAddressFieldsAfterGoogleAutofill(isBilling)
}

function fillInToState(isBilling: boolean = false) {
	const stateIdSelector = _query(`#stateId${isBilling ? 'Billing' : ''}`) as HTMLSelectElement
	// const stateIdVal = terms[3].value
	const stateIdVal = window.addressObj.administrative_area_level_1
	// brief="NY"
	if (stateIdSelector) {
		const options = stateIdSelector.querySelectorAll('option') as NodeListOf<HTMLOptionElement>
		for (let i = 0; i < options.length; i++) {
			const option = options[i]
			// now have option.text, option.value
			if (option.getAttribute('brief') === stateIdVal) {
				stateIdSelector.value = option.getAttribute('value') as string
			}
		}
	}
}

// Bias the autocomplete object to the user's geographical location,
// as supplied by the browser's 'navigator.geolocation' object.
export function geolocate() {
	if (navigator.geolocation) {
		navigator.geolocation.getCurrentPosition((position) => {
			const geolocation = {
				lat: position.coords.latitude,
				lng: position.coords.longitude,
			}
			const circle = new google.maps.Circle({
				center: geolocation,
				radius: position.coords.accuracy,
			})
			// google.maps.places.PlaceSearchRequest.bounds(circle.getBounds())
			// console.info('geolocate is actived')
			return circle.getBounds()
		})
	} else {
		// console.info('geolocate not active')
		return null
	}
}

export function venueGeolocate() {
	if (window.myvars?.venueLatitude || window.myvars?.venueLongitude) {
		return {
			lat: parseFloat(window.myvars?.venueLatitude),
			lng: parseFloat(window.myvars?.venueLongitude)
		}
	} else {
		// console.info('geolocate not active')
		return null
	}
}

export function getCountry() {
	return window.myvars?.countryCode=='uk' ? 'gb' : window.myvars?.countryCode=='us' ? ['us', 'ca'] : window.myvars?.countryCode
}
// window.geolocate = geolocate
window.initAutocomplete = initAutocomplete
window.fillInToForm = fillInToForm as () => void
window.fillInToState = fillInToState as () => void
window.geolocate = geolocate as () => void
window.venueGeolocate = venueGeolocate as () => void
window.getCountry = getCountry as () => string | string[]
